import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import flow from 'lodash/flow';
import classNames from 'clsx';
import withMouseHover from '../../../decorators/hovers/withMouseHover';
import ShareIcon from '../../shared/svgIcons/player/ShareIcon';
import ShareDialog from '../../shared/dialog/ShareDialog';
import FavoriteControl from '../controls/favorite/FavoriteControl';
import connectWithExperiments from '../../../decorators/connectWithExperiments';
import { ENABLE_PLAYBACK_SPEED_CONTROL } from '../../../constants/experiments/player';
import VolumeControl from './VolumeControl';
import SpeedControl from './SpeedControl';
import ActionDrawerHoverContext from './context/ActionDrawerHoverContext';
import css from './action-drawer.module.scss';

export class ActionDrawer extends Component {
  static propTypes = {
    sharingFromPlayer: PropTypes.func.isRequired,
    tunedGuideId: PropTypes.string.isRequired,
    canChangePlaybackRate: PropTypes.bool.isRequired,
    nowPlaying: PropTypes.shape({
      share: PropTypes.shape({
        canShare: PropTypes.bool,
        shareUrl: PropTypes.string,
        shareText: PropTypes.string,
      }),
      image: PropTypes.string,
      subtitle: PropTypes.string,
      title: PropTypes.string,
      slogan: PropTypes.string,
    }).isRequired,

    // withMouseHover
    isHovering: PropTypes.bool.isRequired,
    handleMouseEnter: PropTypes.func.isRequired,
    handleMouseLeave: PropTypes.func.isRequired,
    ENABLE_PLAYBACK_SPEED_CONTROL: PropTypes.bool,
  };

  state = {
    isShowingShareDialog: false,
  };

  toggleShareDialog = () => {
    const isShowingShareDialog = !this.state.isShowingShareDialog;
    this.setState({
      isShowingShareDialog,
    });
    if (isShowingShareDialog) {
      this.props.sharingFromPlayer();
    }
  };

  render() {
    const {
      nowPlaying: { share, image, subtitle, title },
      tunedGuideId,
      isHovering,
      handleMouseEnter,
      handleMouseLeave,
      canChangePlaybackRate,
      [ENABLE_PLAYBACK_SPEED_CONTROL]: isPlaybackRateExperimentEnabled,
    } = this.props;

    const { canShare, shareUrl, shareText } = share || {};

    const shareMeta = {
      guideId: tunedGuideId,
      image,
      subtitle,
      title,
      shareUrl,
      shareText,
    };

    return (
      <div className={css.actionDrawerContainer}>
        <div
          key="speed-control-spacer"
          className={classNames(css.spacer, css.speedTopMarginFix)}
        >
          {isPlaybackRateExperimentEnabled && canChangePlaybackRate && (
            <SpeedControl
              iconContainerClass={classNames(
                css.actionDrawerIconContainer,
                css.speedControlContainer,
              )}
            />
          )}
        </div>
        <div key="volume-spacer" className={css.spacer}>
          <VolumeControl
            iconContainerClass={classNames(
              css.actionDrawerIconContainer,
              css.volumeIconContainer,
            )}
          />
        </div>
        {share &&
          canShare && [
            <div
              key="share-spacer"
              id="playerShareContainer"
              className={classNames(css.spacer, css.shareTopMarginFix)}
            >
              <div
                key="playerShareButton"
                id="playerShare"
                data-testid="playerShareButton"
                className={classNames(
                  css.actionDrawerIconContainer,
                  css.shareIconContainer,
                )}
                onClick={this.toggleShareDialog}
              >
                <ShareIcon width="16px" height="17px" />
              </div>
            </div>,
            <ShareDialog
              key="profileShareDialog"
              shareMeta={shareMeta}
              showEmbed
              isActive={this.state.isShowingShareDialog}
              toggleShareDialog={this.toggleShareDialog}
            />,
          ]}
        <div
          key="follow-spacer"
          id="playerFavoriteContainer"
          className={classNames(css.spacer, css.heartTopMarginFix)}
        >
          <div
            id="playerFavorite"
            className={classNames(css.actionDrawerIconContainer, {
              [css.isHovering]: isHovering,
            })}
          >
            <ActionDrawerHoverContext.Provider
              value={{ handleMouseEnter, handleMouseLeave }}
            >
              <FavoriteControl />
            </ActionDrawerHoverContext.Provider>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { canChangePlaybackRate, nowPlaying } = state.player;

  return {
    canChangePlaybackRate,
    nowPlaying,
  };
}

export default flow(
  connectWithExperiments(ENABLE_PLAYBACK_SPEED_CONTROL),
  connect(mapStateToProps),
  withMouseHover,
)(ActionDrawer);
